export const CLUB_IDS = {
  mongolUndesniiKharwaaKholboo: "mongolUndesniiKharwaaKholboo",
  mongoliinMusunSuriinKholboo: "mongoliinMusunSuriinKholboo",
  mongoliinUwugUriankhaiSuriinKholboo: "mongoliinUwugUriankhaiSuriinKholboo",
  buriadSuriinKholboo: "buriadSuriinKholboo",
} as const;

// Allow environment variable to override the club ID at build time
export const CURRENT_CLUB_ID: string =
  import.meta.env.VITE_CLUB_ID || CLUB_IDS.mongoliinMusunSuriinKholboo;
